import { createElement } from 'react';
import { string } from 'prop-types';
import omit from 'lodash/omit';

const ProductFactory = props => createElement(
  ProductFactory.getComponent(props.type), { ...omit(props, ['type']) }
);

/**
 * Component map registry
 * @type {Map<string, object>}
 */
const ComponentsMap = new Map();

Object.defineProperty(ProductFactory, 'componentsRegistry', {
  value: ComponentsMap
});

/**
 * Register components
 * @param {string} type
 * @param {object} component
 */
ProductFactory.register = (type, component) => {
  if (!ProductFactory.componentsRegistry.has(type)) {
    ProductFactory.componentsRegistry.set(type, component);
  }
};

/**
 * Check if contains component
 * @param {string} type
 */
ProductFactory.has = type => ProductFactory.componentsRegistry.has(type);

/**
 * Returns a component
 * @param {string} type
 * @returns {object} component
 */
ProductFactory.getComponent = type => {
  if (!ProductFactory.has(type)) {
    throw new Error('You forgot to specify which component type you want !');
  }
  return ProductFactory.componentsRegistry.get(type);
};

ProductFactory.displayName = 'ProductFactory';

ProductFactory.propTypes = {
  type: string
};

export default ProductFactory;
